import { Component, OnInit } from '@angular/core';
import { MatBottomSheetRef } from '@angular/material/bottom-sheet';
@Component({
  selector: 'app-gps-logger-bottom-sheet',
  templateUrl: './gps-logger-bottom-sheet.component.html',
  styleUrls: ['./gps-logger-bottom-sheet.component.scss']
})
export class GpsLoggerBottomSheetComponent implements OnInit {

  constructor(private bottomSheetRef: MatBottomSheetRef<GpsLoggerBottomSheetComponent>) { }

  ngOnInit() {
  }
  close(): void {
    this.bottomSheetRef.dismiss();
  }
}
